import {FC} from 'react'
import styled from 'styled-components'

import {theme} from '../../theme/theme'
import {useLocale} from '../../utils/i18n'
import {ChannelTile, MINT_TILE, NEUTRAL_TILE} from './channel-logo'

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
  margin-bottom: 16px;
`

const Card = styled.button`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  text-align: start;
  min-height: 132px;
  padding: 16px;
  background: #fff;
  border: 1.5px solid #e5e7eb;
  border-radius: 16px;
  cursor: pointer;
  font: inherit;
  color: inherit;
  @media (min-width: 480px) {
    aspect-ratio: 1 / 1;
    min-height: 0;
  }
  &:hover,
  &:focus-visible {
    border-color: ${theme.colors.primary};
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
    outline: none;
  }
`

const Title = styled.div`
  margin-top: auto;
  padding-top: 12px;
  font-size: 15px;
  font-weight: 700;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
`

const Sub = styled.div`
  margin-top: 4px;
  font-size: 13px;
  color: #6b7280;
`

const glyphProps = {
  viewBox: '0 0 24 24',
  width: 25,
  height: 25,
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 1.8,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
  'aria-hidden': true,
} as const

const StoreIcon = () => (
  <svg {...glyphProps}>
    <path d='M4 9.5 5.5 4h13L20 9.5M4 9.5a2.7 2.7 0 0 0 5.3 0 2.7 2.7 0 0 0 5.4 0 2.7 2.7 0 0 0 5.3 0M5.5 12.5V20h13v-7.5M10 20v-4.5h4V20' />
  </svg>
)

const ToolIcon = () => (
  <svg {...glyphProps}>
    <path d='M14.7 6.3a4 4 0 0 0-5.4 5L4 16.6V20h3.4l5.3-5.3a4 4 0 0 0 5-5.4l-2.5 2.5-2.2-.5-.5-2.2z' />
  </svg>
)

export const HelpChoice: FC<{onVenue: () => void; onTechnical: () => void}> = ({onVenue, onTechnical}) => {
  const {l} = useLocale()
  return (
    <Grid>
      <Card
        type='button'
        onClick={onVenue}
      >
        <ChannelTile
          size={40}
          tile={MINT_TILE}
        >
          <StoreIcon />
        </ChannelTile>
        <Title>{l('help_with_booking_or_venue')}</Title>
        <Sub>{l('help_venue_card_sub')}</Sub>
      </Card>
      <Card
        type='button'
        onClick={onTechnical}
      >
        <ChannelTile
          size={40}
          tile={NEUTRAL_TILE}
        >
          <ToolIcon />
        </ChannelTile>
        <Title>{l('help_technical_problem')}</Title>
        <Sub>{l('help_technical_card_sub')}</Sub>
      </Card>
    </Grid>
  )
}
